'use strict'

export function request_support() {
	const $$ = require('jquery')

	let removeRequire = function(type) {
		if (type) {
			$$('#txt_title').val('')
			$$('#txt_company').val('')
			$$('textarea').val('')
			$$('input[name ="type"]').prop('checked', false)
			$$('input[name ="priority"]').prop('checked', false)
		}
		$$('.text-error').remove()
		$$('input').removeClass('is-invalid')
		$$('textarea').removeClass('is-invalid')
	}

	//note event request support
	let modalRequest = document.getElementById('modal_request_support')

	let btnRequest = document.getElementById('btn_make_request_support')

	let spanRequest = document.getElementsByClassName('close')[0]

	let btnConfirm = document.getElementById('btn_confirm')

	let btnExit = document.getElementById('btn_exit')

	if (btnRequest)
		btnRequest.onclick = function() {
			$$(modalRequest).addClass('show')
			modalRequest.style.display = 'block'
		}

	if (spanRequest)
		spanRequest.onclick = function() {
			removeRequire(true)
			modalRequest.style.display = 'none'
		}

	if (btnExit)
		btnExit.onclick = function() {
			removeRequire(true)
			modalRequest.style.display = 'none'
		}

	if (modalRequest)
		window.onclick = function(event) {
			if (event.target === modalRequest) {
				removeRequire(true)
				modalRequest.style.display = 'none'
			}
		}

	if (btnConfirm)
		btnConfirm.onclick = function() {
			let url = document.getElementById('request_supports_form').action
			$$('#content').addClass('loading ')
			$$.ajax({
				type: 'GET',
				url: url,
				data: $$('#request_supports_form').serialize(),
			}).done(function(response) {
				removeRequire(true)
				let message = response[0].message
				Swal.fire({
					icon: 'success',
					title: message,
					showConfirmButton: true,
				})
				modalRequest.style.display = 'none'
				$$('#content').removeClass('loading ')
			}).fail(function(response) {
				let errors = response.responseJSON.errors || response.responseJSON
				removeRequire()

				let errorCount = 0

				$$.each(errors, function(i, item) {
					errorCount++
					let errorMessage = '<p class="text-danger text-error">' + item + '</p>'

					$$('input[name ="' + i + '"]').addClass('is-invalid')
					$$('input[name ="' + i + '"]').parent().append(errorMessage)
					$$('textarea[name ="' + i + '"]').addClass('is-invalid')
					$$('textarea[name ="' + i + '"]').parent().append(errorMessage)
					$$('#content').removeClass('loading ')
				})
				$$('#content').removeClass('loading ')
			})
		}
}
